import Text from '@cartwhl/ui/base/TextNew';
import Button from '@cartwhl/ui/input/Button';
import Modal from '@cartwhl/ui/molecules/Modal';

import { batchBodyAccentBgClass } from '../../../../shared/batchMotionBodyAccentClasses';
import CartographerMotionActorPickerStage from './CartographerMotionActorPickerStage';

export type CartographerMotionActorPickerModalProps = {
  open: boolean;
  motionID: string | null;
  bodyCount: number;
  bvhURLs?: string[];
  mhrBvhURLs?: string[];
  mhrIdentityJsonURLs?: string[];
  onOpenChange: (open: boolean) => void;
  onSelectBodyIndex: (bodyIndex: number) => void;
};

export default function CartographerMotionActorPickerModal({
  open,
  motionID,
  bodyCount,
  bvhURLs = [],
  mhrBvhURLs = [],
  mhrIdentityJsonURLs = [],
  onOpenChange,
  onSelectBodyIndex,
}: CartographerMotionActorPickerModalProps) {
  const hasStagePreview =
    Boolean(motionID) && (bvhURLs.length > 0 || mhrBvhURLs.length > 0);

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title="Select an actor"
      maxWidth={hasStagePreview ? 720 : 420}
      footer={
        <Button
          type="button"
          variant="secondary"
          size="lg"
          onClick={() => onOpenChange(false)}
        >
          Cancel
        </Button>
      }
    >
      <div className="flex flex-col gap-4">
        <Text token="14" className="text-secondary text-pretty">
          This motion has multiple actors. Choose which one to apply to your
          character.
        </Text>
        {hasStagePreview && motionID ? (
          <CartographerMotionActorPickerStage
            jobId={motionID}
            bvhURLs={bvhURLs}
            mhrBvhURLs={mhrBvhURLs}
            mhrIdentityJsonURLs={mhrIdentityJsonURLs}
          />
        ) : null}
        <div className="flex flex-col gap-2">
          {Array.from({ length: Math.max(bodyCount, 0) }, (_, bodyIndex) => (
            <Button
              key={bodyIndex}
              type="button"
              variant="secondary"
              size="lg"
              className="justify-start"
              onClick={() => onSelectBodyIndex(bodyIndex)}
            >
              <span className="inline-flex items-center gap-3">
                <span
                  className={`inline-block h-2.5 w-2.5 shrink-0 rounded-full ${batchBodyAccentBgClass(bodyIndex)}`}
                  aria-hidden
                />
                Actor {bodyIndex + 1}
              </span>
            </Button>
          ))}
        </div>
      </div>
    </Modal>
  );
}
